"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const Stringify_1 = require("./Stringify");
exports.DropdownComponent = ({ data, className, col }) => {
    const _data = data.map((d) => ({
        label: d.label || d,
        value: d.value || d,
    }));
    return (react_1.default.createElement(reactstrap_1.Dropdown, { tag: "a", className: className },
        react_1.default.createElement(reactstrap_1.DropdownToggle, null,
            react_1.default.createElement(reactstrap_1.DropdownMenu, null, _data.map((d) => (react_1.default.createElement(reactstrap_1.DropdownItem, { className: "cursor-pointer", key: d.value },
                react_1.default.createElement(Stringify_1.Stringify, { col: col, value: d.label }))))))));
};
//# sourceMappingURL=DropdownComponent.js.map